import { render, staticRenderFns } from "./ReporteriaInfo.vue?vue&type=template&id=13be2250&"
import script from "./ReporteriaInfo.vue?vue&type=script&lang=js&"
export * from "./ReporteriaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports